<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <div class="search_wrapper">
          <div class="common_search_wrapper">
            <Input
              class="search-ipt"
              type="text"
              v-model="searchIpt.studentName"
              placeholder="请输入学生姓名"
              clearable
            />
            <!--<DatePicker type="date" placeholder="请选择查询日期" @on-change="getDateTime"></DatePicker>-->
            <Button type="primary" icon="md-search" class="search_tn" @click="bluetoothData">搜索</Button>
          </div>
        </div>
      </div>
      <Table
        class="main_table"
        size="large"
        stripe
        border
        :columns="tableHeader"
        :data="dataList"
        :row-class-name="rowClass"
      >
        <!--<template slot-scope="{row}" slot="className">-->
        <!--{{row.grade}}{{row.className}}-->
        <!--</template>-->
        <template slot-scope="{row}" slot="data">
          <a class="jump_color" :href="trackUrl + row.data" target="_blank">蓝牙数据</a>
        </template>
        <template slot-scope="{row}" slot="hint">
          <span v-if="row.hint== ''">无</span>
          <span v-if="row.hint">{{row.hint}}</span>
        </template>
        <template slot-scope="{row}" slot="status">
          <span v-if="row.status == 0">上传完成</span>
          <span v-if="row.status == 1">已处理</span>
          <span v-if="row.status == 4">有错误</span>
        </template>
        <template slot-scope="{row,index}" slot="action">
          <a
            class="jump_color"
            v-if="row.roleId == 5"
            @click="jumpStudenetBluetooth(row.id,index)"
          >学生蓝牙</a>
          <a class="jump_color" v-if="row.roleId == 4" @click="jumpTeacherJudge(row.id,index)">老师批改</a>
          <a class="jump_color" @click="againCorrectBluetooth(row.id)">重新批改</a>
        </template>
      </Table>
    </div>
    <paging
      :totalNum="totalNum"
      :currentNum="currentNum"
      :pageSize="pageSize"
      @pageCallback="bluetoothData"
    ></paging>
  </div>
</template>
<script>
import paging from "../templates/Paging.vue";
import { _bluetoothData,_againCorrectBluetooth } from "../api/api";
import { YearMonthDate, alertTips, dealTime } from "../common/common";
import globalData from "../common/Global";
export default {
  name: "Bluetooth",
  components: { paging },
  data() {
    return {
      pageSize: 10, // 每页条数
      currentNum: 1, // 当前页码
      totalNum: 0, // 数据总条数
      trackUrl: globalData.trackUrl,
      searchIpt: {
        studentName: "",
        dateTime: ""
      }, // 搜索信息
      dataList: [], // 蓝牙数据列表
      selectedIndex: -1, //当前选中的题目
      tableHeader: [
        {
          title: "编号",
          key: "id"
        },
        {
          title: "学生",
          key: "username"
        },
        {
          title: "提交者",
          key: "uploaderName"
        },
        {
          title: "提交时间",
          key: "createTime"
        },
        {
          title: "后台处理时间",
          key: "updateTime"
        },
        {
          title: "蓝牙数据",
          key: "data",
          slot: "data"
        },
        {
          title: "错误信息",
          key: "hint",
          slot: "hint"
        },
        {
          title: "状态",
          key: "status",
          slot: "status"
        },
        {
          title: "操作",
          key: "action",
          slot: "action",
          width: 240
        }
      ]
    };
  },
  methods: {
//    蓝牙数据重新批改
    againCorrectBluetooth(id){
      const self = this;
      _againCorrectBluetooth(id).then(res => {
        if(res.code === 0) {
          alertTips("success", '重新批改成功');
        }
      })
    },
    //  获取蓝牙数据提交情况列表(客服调试)
    bluetoothData(msg) {
      const self = this;
      self.selectedIndex = -1;
      sessionStorage.setItem("studentName", self.searchIpt.studentName);
      this.currentNum =
        typeof msg === "object" && msg.pageNum ? msg.pageNum : 1;
      let paramsInfo = {
        page: this.currentNum - 1,
        size: self.pageSize,
        name: self.searchIpt.studentName
      };
      _bluetoothData({ params: paramsInfo })
        .then(res => {
          if (res.code === 0) {
            res.data.content.length > 0 &&
              res.data.content.forEach(item => {
                item.createTime = dealTime(item.createTime);
                item.updateTime = dealTime(item.updateTime);
              });
            self.dataList = res.data.content;
            self.totalNum = res.data.total;
            //            self.$router.push(`/bluetooth/${paramsInfo.page}/${paramsInfo.name}?`)
          } else {
            alertTips("error", res.message);
          }
        })
        .catch(err => {
          alertTips("error", "请求失败，请刷新");
        });
    },
    // 跳转到学生蓝牙
    jumpStudenetBluetooth(id, index) {
      this.selectedIndex = index;
      this.$router.push(`/studentbluetooth?id=${id}`);
    },
    //      点击行的颜色
    rowClass(row, index) {
      for (let item of this.dataList) {
        if (index == this.selectedIndex) {
          return "selected_row_class";
        } else {
          return "";
        }
      }
    },
    //跳转老师批改
    jumpTeacherJudge(id) {
      this.selectedIndex = index;
      this.$router.push(`/teacherJudgebluetooth?id=${id}`);
    },
    // 跳转到答题卡详情
    jumpDetails(id) {
      this.$router.push(`/studentBluetoothDetails?id=${id}`);
    },
    //      获取要查询的日期
    getDateTime(msg) {
      this.searchIpt.dateTime = msg;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (/studentbluetooth|teacherJudgebluetooth/.test(to.path)) {
      next();
    } else {
      if (this.searchIpt.studentName) {
        this.searchIpt.studentName = "";
        this.bluetoothData();
      } else {
        next();
      }
    }
  },
  created() {
    this.bluetoothData();
  }
};
</script>
<style>
.ivu-table-tbody .selected_row_class td {
  background-color: #cfcece !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Bluetooth.vue